// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./welcome-block-image.jpg");
var dir = previousRequest.replace("welcome-block-image.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "welcome-block-image.jpg",
	name: "welcome-block-image",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/welcome-block-image.jpg
// module id = 1029
// module chunks = 4